export default "__VITE_ASSET__6d7d8c5b__"